import { Constants } from "appConstants";
import "./styles.scss";

type DetailsSidePanelProps = {
	fields: string[];
	data: { [field: string]: any };
};

export default function DetailsSidePanel({
	fields,
	data
}: Readonly<DetailsSidePanelProps>) {
	return (
		<div className="details-side-panel">
			{fields.map((field: string) => (
				<div
					key={`${field}-wrapper`}
					className={field === "id" ? "id-field-wrapper" : "field-wrapper"}
				>
					<div key={field} className="field-name">
						{
							(Constants.strings.fields as { [string: string]: string })?.[
								field
							]
						}
					</div>
					<div key={`${field}-value`} className="field-value">
						{data?.[field]}
					</div>
				</div>
			))}
		</div>
	);
}
